export const REDIRECT_LOADER_DURATION = 2000;
